import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";

import { LoadingAction } from "../loading/loading.action";
import { CoreState } from "../state";

@Injectable({
	providedIn: "root",
})
export class LoadingService {
	constructor(
		private loadingAction: LoadingAction,
		private store: Store<CoreState>
	) {}

	open() {
		this.store.dispatch(this.loadingAction.open());
	}

	close() {
		this.store.dispatch(this.loadingAction.close());
	}
}
